import axios from 'axios'
import { useAuthStore } from '@/stores/auth' // מניח שהחנות שלך מבוססת Pinia

// יצירת מופע של axios נפרד, כדי למנוע לולאה אינסופית בקריאה לרענון טוקן
const axiosInstance = axios.create()

// הוספת ה-interceptor לבקשות
axiosInstance.interceptors.response.use(
  (response) => response, // אם הבקשה הצליחה, מחזירים את התגובה
  async (error) => {
    const authStore = useAuthStore()
    const originalRequest = error.config

    // בדוק אם השגיאה היא 401 והיא לא נגרמה על ידי רענון טוקן
    // ושהבקשה לא סומנה כבר כניסיון חוזר
    if (
      error.response?.status === 401 &&
      originalRequest.url !== '/api/auth/refresh_token' &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true // סמן את הבקשה כניסיון חוזר

      // console.log('🚀 ~ axiosInstance ~ 401 error, trying to refresh token...')

      try {
        const refreshSuccess = await authStore.refreshToken() // רענן את הטוקן

        if (refreshSuccess) {
          // console.log(
          // '🚀 ~ axiosInstance ~ Token refreshed successfully, retrying original request...'
          // )
          // עדכון הכותרת של הבקשה המקורית עם הטוקן החדש
          originalRequest.headers['Authorization'] = `Bearer ${authStore.token}`
          // בצע את הבקשה המקורית שוב עם הטוקן החדש
          return axiosInstance(originalRequest)
        } else {
          // console.log('🚀 ~ axiosInstance ~ Token refresh failed, logging out.')

          authStore.logout()

          return Promise.reject(new Error('פג תוקף הפגישה. אנא התחבר שוב.'))
        }
      } catch (refreshError) {
        console.error(
          '🚀 ~ axiosInstance ~ Error during token refresh attempt in interceptor:',
          refreshError
        )
        authStore.logout() // ננקה את הטוקן והמשתמש במקרה של שגיאה ברענון
        return Promise.reject(refreshError) // החזר את השגיאה
      }
    }

    // אם השגיאה לא הייתה 401 או שהייתה שגיאה אחרת, החזר את השגיאה המקורית
    return Promise.reject(error)
  }
)

// הקטע הבא מיותר, כי אנחנו כבר לא שומרים את הטוקן ב-localStorage
// // ודא שכותרת ברירת המחדל מוגדרת אם יש טוקן התחלתי (נדיר עכשיו)
// const initialToken = useAuthStore().token
// if (initialToken) {
//   axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${initialToken}`
// }

export default axiosInstance
